import Config from '@/config'
import { resolveMarketplaceBase } from '@/utils/resolveMarketplaceBase'

const FETCH_TIMEOUT_MS = 8000

const isWindow = (window) => Boolean(window) && typeof window.from === 'string' && typeof window.to === 'string'

/**
 * The platform season calendar as `{ [seasonId]: [{ from, to }] }` (inclusive
 * YYYY-MM-DD windows), or `null` when the endpoint is unavailable or unusable.
 * Never rejects; callers treat `null` as "everything in season".
 */
export const fetchSeasonCalendar = async () => {
  const base = resolveMarketplaceBase(Config.ahaslideMarketplaceUrl, Config.presenterDomain)
  const controller = typeof AbortController !== 'undefined' ? new AbortController() : null
  const timer = controller ? setTimeout(() => controller.abort(), FETCH_TIMEOUT_MS) : null
  try {
    const response = await fetch(
      `${String(base).replace(/\/+$/, '')}/api/slide-types/seasons`,
      controller ? { signal: controller.signal } : undefined,
    )
    if (!response.ok) return null
    const data = await response.json()
    if (!data || !Array.isArray(data.seasons)) return null
    return data.seasons
      .filter((season) => season && typeof season.id === 'string' && Array.isArray(season.windows))
      .reduce((calendar, season) => ({ ...calendar, [season.id]: season.windows.filter(isWindow) }), {})
  } catch (e) {
    return null
  } finally {
    if (timer) clearTimeout(timer)
  }
}
